import React, { Component } from 'react';
import CDBBlogViewer from "../cdb-blog-viewer/CDBBlogViewer";

interface NoAccessPageProps {
}

export class NoAccessPage extends Component<NoAccessPageProps,any> {
    static displayName = NoAccessPage.name;

    constructor(props: NoAccessPageProps) {
        super(props);

        this.state = {

        }
    }

    async componentDidMount() {
    }
    
    render () {
        return (
            <div className={"cdb-admin-content cdb-admin-content--column"}>
                <div className="card">
                    <div className="card__header">
                        <span className={"card__title"}>Welcome to Cloud Design Box Admin</span>
                    </div>

                    <div className="card__content">
                        <span>
                            You don't have access to this site.<br/><br/>
                            Please speak to your IT support team to make sure you are associated with the correct school(s).<br/><br/>
                            If you are IT support, ask a <b>CDB Portal School or Tenant Manager</b> to give you access. You can find further information <a
                            href="https://www.clouddesignbox.co.uk/documentation#referencematerials">here.</a>
                        </span>
                    </div>
                </div>
                <CDBBlogViewer/>
            </div>
        );
    }
}
